import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faPen, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import Pagination_Holder from "../../../../../../../common/common_components/pagination_holder/Pagination_Holder";
import { formatDate } from "../../../../../../../utils/common";
import Image_Show_Modal from "../../../../../../../common/common_modal/image_show_modal/image_show_modal";
import Multi_Image_Show_Modal from "../../../../../../../common/common_modal/multiimage_show_modal/multiimage_show_modal";
import Delete_offcanvas from "../../../../../../../common/common_offcanvas/delete_offcanvas/Delete_offcanvas";
import { Delete,GetAll } from "../../../../../../../../src/features/admin/quality_management/management_system/Slice";
import { useDispatch, useSelector } from "react-redux";
import { FixIDS } from "../../../../../../../utils/fixIDS";

function Internal_Audit_table({
  onEdit,
  managementdetails,
  setCurrentPage,
  currentPage,
  managementsystemTypeId
}) {
  const getStatusClass = (status) => {
    switch (status) {
      case "Pending":
        return "red";
      default:
        return "";
    }
  };
  const dispatch = useDispatch();
  const itemsPerPage = managementdetails?.per_page || 10;
  const totalPages = managementdetails?.total_pages || 1;

  const [showDelete, setDelete] = useState(false);
  const [selectedDeleteId, setSelectedDeleteId] = useState(null);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const permissions = useSelector((state) => state.auth.permissions);
  const haveEditPermission = permissions?.includes(FixIDS.management_system.Edit);
  const haveDeletePermission = permissions?.includes(FixIDS.internal_audit.Delete);
  const haveViewPermission = permissions?.includes(FixIDS.internal_audit.View);

  const getFileUrl = (path) => {
    if (!path) return null;
    return `${process.env.REACT_APP_IMG_URL}${path}`;
  };

  const [show, setShow] = useState(false);

  const [showData, setShowData] = useState("");
  const handleDelete = async () => {
    if (!selectedDeleteId) return;

    try {
      await dispatch(Delete(selectedDeleteId)).unwrap(); 
       await dispatch(
        GetAll({
          page: 1,
          per_page: 10,
          management_system_type_id: managementsystemTypeId,
        }),
      );
      // call redux thunk
      //fetchCustomers(currentPage); // refresh the table
      // setDelete(false); // close offcanvas
      setSelectedDeleteId(null); // reset
    } catch (err) {
      console.error("Delete failed", err);
      alert("Delete failed");
    }
  };
  return (
    <section className="Imperiality_table">
      <div className="common_table_container theme_bg">
        <div className="table-responsive">
          <table className="common_table table table-striped customer_table">
            <thead>
              <tr>
                <th>Sr. No</th>
                <th> Date</th>
                <th>Document Name</th>
                <th>Start Date</th>
                <th>End Date</th>
                <th>Attached File</th>
                <th>Remarks</th>
                <th>Status</th>
                <th>Corrective Action</th>
              </tr>
            </thead>

            <tbody>
              {managementdetails?.data.length > 0 ? (
                managementdetails?.data?.map((row, index) => {
                  const fileUrl = getFileUrl(row.attach_file);

                  return (
                    <tr key={row.id}>
                      <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                      <td>{formatDate(row?.createdAt)}</td>

                      <td>{row.name || "---"}</td>

                      <td>{formatDate(row.start_date)}</td>
                      <td>{formatDate(row.end_date)}</td>

                      <td className="file_actions">
                        <div
                          className="action_icons"
                          onClick={() => {
                            setShow(true);
                            setShowData(row);
                          }}
                        >
                          { haveViewPermission && <FontAwesomeIcon icon={faEye} />}
                        </div>
                      </td>

                      <td>{row.remark || "---"}</td>

                      {/* STATUS */}
                      <td
                        className={`status ${getStatusClass(
                          row?.Management_System_Requirement_Status?.name,
                        )}`}
                      >
                        {row?.Management_System_Requirement_Status?.name ||
                          "---"}
                      </td>

                      {/* CORRECTIVE ACTION */}
                      <td>
                        <div className="action_icons">
                          { haveEditPermission && <FontAwesomeIcon
                            icon={faPen}
                            style={{ cursor: "pointer" }}
                            onClick={() => onEdit(row.id)}
                          />}

                          { haveDeletePermission && <FontAwesomeIcon
                            icon={faTrashCan}
                            onClick={() => {
                              setSelectedDeleteId(row.id); // store ID
                              setDelete(true); // open offcanvas
                            }}
                          />}
                        </div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="8" className="text-center">
                    No Records Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* PAGINATION */}
      <div className="comon_page_footer">
        <div className="show_entry_div">
          <p className="show_text">
            Showing {(currentPage - 1) * itemsPerPage + 1} To{" "}
            {Math.min(
              currentPage * itemsPerPage,
              managementdetails?.data?.length,
            )}{" "}
            Of {managementdetails?.total || 0} Entries
          </p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>

      <Multi_Image_Show_Modal
        onHide={() => setShow(false)}
        show={show}
        showData={showData}
        imgSrc={showData?.Management_System_Record_Files}
      />

      <Delete_offcanvas
        show={showDelete}
        handleClose={() => setDelete(false)}
        handleDelete={handleDelete}
        offcanvasHeading="Delete Internal Audit"
        massageText={"Internal Audit"}
      />
    </section>
  );
}

export default Internal_Audit_table;
